export const range_for = (count: number): string =>
  count > 1 ? `1-${count}` : count ? `${count}` : ""
